import clsx from "clsx";
import React, { PropsWithChildren } from "react";

import { CommonColors } from "../../../../types/colors";
import { ScrollableContainer } from "../../../layouts/scrollable-container";

export interface PillTabsHeaderProps {
  className?: string;
}

export function PillTabsHeader({ className, children }: PropsWithChildren<PillTabsHeaderProps>) {
  return (
    <ScrollableContainer
      className={clsx("mx-2 px-8 lg:px-20", className)}
      backgroundColor={CommonColors.Neutral}
    >
      {children}
    </ScrollableContainer>
  );
}
